import listActions from 'src/modules/pendiente/list/pendienteListActions';
import PendienteService from 'src/modules/pendiente/pendienteService';
import Errors from 'src/modules/shared/error/errors';
import { i18n } from 'src/i18n';
import { getHistory } from 'src/modules/history';
import Message from 'src/view/shared/message';

const prefix = 'PENDIENTE_DESTROY';

const pendienteDestroyActions = {
  DESTROY_STARTED: `${prefix}_DESTROY_STARTED`,
  DESTROY_SUCCESS: `${prefix}_DESTROY_SUCCESS`,
  DESTROY_ERROR: `${prefix}_DESTROY_ERROR`,

  DESTROY_ALL_STARTED: `${prefix}_DESTROY_ALL_STARTED`,
  DESTROY_ALL_SUCCESS: `${prefix}_DESTROY_ALL_SUCCESS`,
  DESTROY_ALL_ERROR: `${prefix}_DESTROY_ALL_ERROR`,

  doDestroy: (id) => async (dispatch) => {
    try {
      dispatch({
        type: pendienteDestroyActions.DESTROY_STARTED,
      });

      await PendienteService.destroyAll([id]);

      dispatch({
        type: pendienteDestroyActions.DESTROY_SUCCESS,
      });

      Message.success(
        i18n('entities.pendiente.destroy.success'),
      );

      dispatch(listActions.doFetchCurrentFilter());

      getHistory().push('/pendiente');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: pendienteDestroyActions.DESTROY_ERROR,
      });
    }
  },

  doDestroyAll: (ids) => async (dispatch) => {
    try {
      dispatch({
        type: pendienteDestroyActions.DESTROY_ALL_STARTED,
      });

      await PendienteService.destroyAll(ids);

      dispatch({
        type: pendienteDestroyActions.DESTROY_ALL_SUCCESS,
      });

      if (listActions) {
        dispatch(listActions.doClearAllSelected());
        dispatch(listActions.doFetchCurrentFilter());
      }

      Message.success(
        i18n('entities.pendiente.destroyAll.success'),
      );

      getHistory().push('/pendiente');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: pendienteDestroyActions.DESTROY_ALL_ERROR,
      });
    }
  },
};

export default pendienteDestroyActions;
